import React, {useState} from 'react';
import classNames from 'classnames';

/* Validation */
import {Formik} from 'formik';
import validationSchema from './formConfig';

/* Gjensidige Core 20 Imports */
import utils from '@gjensidige/core-utilities-css';

/* Gjensidige Core 30 Imports */
import {Alert} from '@gjensidige/core-components/lib/alerts/default';
import {Col, Container, Row} from '@gjensidige/nci-core-grid';
import {Input} from '@gjensidige/core-components/lib/forms/input';

/* API */
import {STATUS_MESSAGE} from './statusMessages';
import {CallMeResult, getHttpStatusAndJson, sendCallMe} from "./callMe/sendCallMe";
import {Button} from "@gjensidige/core-components/lib/button";

const CallMeEjerskifte = () => {
  const [formData, setFormData] = useState({
    name: '',
    phoneNumber: ''
  });
  const [statusMessage, setStatusMessage] = useState('');
  const [statusCode, setStatusCode] = useState('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleFormData = (formData: any) => {
    setIsLoading(true);
    setStatusCode('');
    sendCallMe({
      phoneNumber: formData.phoneNumber
    }).then((result) => getHttpStatusAndJson(result).then((parsed) => setResults(parsed)))
      .catch(() => {
        setStatusCode('-1')
        setStatusMessage(STATUS_MESSAGE.ERROR);
      })
  };

  const setResults = (callMeResult: CallMeResult) => {
    setStatusCode(callMeResult.data.code);
    setIsLoading(false)
    switch (callMeResult.data.code) {
      case '0':
        setStatusMessage(STATUS_MESSAGE.OK);
        break;
      case '3001':
        setStatusMessage(STATUS_MESSAGE.INVALID_PHONE);
        break;
      case '2010':
        setStatusMessage(STATUS_MESSAGE.ALREADY_REGISTERED);
        break;
      case '4005':
        setStatusMessage(STATUS_MESSAGE.CLOSED);
        break;
      case '-1':
      case '1200':
      case '15':
        setStatusMessage(STATUS_MESSAGE.ERROR);
        break;
    }
  }

  return (
    <Container className={utils['mt-2']}>
      {statusCode === '0' ? (
        <Row className={utils['justify-content-center']}>
          <Alert
            alertType="success"
            showIcon
            style={{whiteSpace: 'pre-line'}}
            title="Tak for din henvendelse"
            text={`Vi kontakter dig hurtigst muligt i tidsrummet man-tor: 10:00-18:00 og fre: 10:00-15:30.

            HUSK at have tilstands- og el-rapport klar.
            Hvis du ikke har rapporterne, kan disse rekvireres hos ejendomsmægleren eller hentes på deres hjemmeside.`}
            className={utils['mb-3']}
          />
        </Row>
      ) : (
        <Formik
          enableReinitialize
          initialValues={{
            name: formData.name,
            phoneNumber: formData.phoneNumber
          }}
          validationSchema={validationSchema()}
          onSubmit={() => {
            handleFormData(formData);
          }}
        >
          {(props) => {
            const {
              handleSubmit,
              handleBlur,
              setFieldValue,
              touched,
              errors
            } = props;
            return (
              <form onSubmit={handleSubmit} className={utils['pb-3']}>
                <Row
                  className={classNames(
                    utils['mb-3'],
                    utils['justify-content-center']
                  )}
                  style={{justifyContent: 'center'}}
                ></Row>
                <Row className={utils['justify-content-center']}>
                  <Col lg={6}>
                    <Input
                      id="name"
                      labelText="Navn *"
                      name="name"
                      className={utils['pb-2']}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setFieldValue('name', event.target.value);
                        setFormData({...formData, name: event.target.value});
                      }}
                      onBlur={handleBlur}
                      invalid={!!(touched.name && errors.name)}
                      errorText={errors.name}
                      value={formData.name}
                    />
                    <Input
                      id="phone-number"
                      labelText="Telefonnummer *"
                      name="phoneNumber"
                      className={utils['pb-2']}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setFieldValue('phoneNumber', event.target.value);
                        setFormData({
                          ...formData,
                          phoneNumber: event.target.value
                        });
                      }}
                      onBlur={handleBlur}
                      invalid={!!(touched.phoneNumber && errors.phoneNumber)}
                      errorText={errors.phoneNumber}
                      value={formData.phoneNumber}
                    />
                    <Button variant={'critical'} loading={isLoading} type="submit" flexible>
                      Ring mig op
                    </Button>
                  </Col>
                </Row>
              </form>
            );
          }}
        </Formik>
      )}
      {statusCode !== '0' && statusCode !== '' && (
        <Row className={utils['justify-content-center']}>
          <Col lg={6}>
            <Alert
              alertType="error"
              showIcon
              title="Der skete en fejl."
              text={statusMessage}
              className={utils['mb-3']}
            />
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default CallMeEjerskifte;
